export default __webpack_public_path__ + "static/media/highRisk.b9e42ea2.svg";